import React, { useState } from 'react';
import { Link } from 'gatsby';
import Slider from "react-slick";
import Layout from '../components/Layout';
import { StaticImage } from "gatsby-plugin-image"

// add bootstrap css 
import 'bootstrap/dist/css/bootstrap.css'

// slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import '../styles/fontello/css/conecdata.css';

import '../styles/globals.css';

import * as styles from '../styles/home.module.css';

export default function Home() {
  const SETTINGS_DESKTOP = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const SETTINGS_MOBILE = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      //   {
      //     breakpoint: 1280,
      //     settings: {
      //       slidesToShow: 1.5,
      //     }
      //   },
      // {
      //   breakpoint: 640,
      //   settings: {
      //     slidesToShow: 1,
      //   }
      // }
    ]
    // centerPadding: '10px',
  };
  const SLIDES_DESKTOP = [
    '/img/slides/desktop/loja.jpg',
    '/img/slides/desktop/busca.jpg',
    '/img/slides/desktop/promocoes.jpg',
    '/img/slides/desktop/departamentos.jpg',
    '/img/slides/desktop/detalhes-produto.jpg',
    '/img/slides/desktop/carrinho.jpg',
    '/img/slides/desktop/pedido.jpg',
    '/img/slides/desktop/detalhes-pedido.jpg',
  ];
  const SLIDES_MOBILE = [
    '/img/slides/app/loja.jpg',
    '/img/slides/app/busca.jpg',
    // '/img/slides/app/promocoes.jpg',
    '/img/slides/app/departamentos.jpg',
    '/img/slides/app/detalhes-produto.jpg',
    '/img/slides/app/carrinho.jpg',
    '/img/slides/app/pedido.jpg',
    '/img/slides/app/detalhes-pedido.jpg',
  ];

  const [lojaModeloTab, setLojaModeloTab] = useState('desktop');

  return (
    <>
      <nav id="top" className="navbar navbar-custom navbar-expand-sm">
        {/*  sticky-top */}
        <div className="container">
          <a className="navbar-brand" href="#hero">
            <img src="https://firebasestorage.googleapis.com/v0/b/mercadeiro-896b2.appspot.com/o/misc%2Flogo_mercadeiro.svg?alt=media"
              className="img-fluid"
              width="200px"
              alt="" />
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-menu" aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
            <span className="icon-rows text-white"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbar-menu">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <a className="nav-link" href="#hero">
                  <span className="icon-home"></span>
                </a>
              </li>

              <li className="nav-item m-auto">
                <a className="nav-link" href="#integracao">
                  Integração
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#suporte">
                  Suporte
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#base-produtos">
                  Base de produtos
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#loja-modelo">
                  Loja Modelo
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#material-apoio">
                  Material apoio
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <Layout>
        <section id="hero" className="bg-white pb-5">
          <div className={"container " + styles.heroContainer}>
            <div className={"p-lg-5 " + styles.comercianteTxt}>
              <h1>
                <strong className="text-warning o-80">
                  COMERCIANTE
                </strong>
              </h1>
              <h2 className="txt-bold">
                Você quer vender online <span className="text-warning">integrando</span> sua loja virtual com seu sistema
                gerencial <span className="o-30">(ERP)</span> atual?
              </h2>

              <Link to="comerciante">
                <button type="button"
                  className="btn btn-outline-warning btn-lg mt-4">
                  Quero saber mais...
                </button>
              </Link>
            </div>

            <div className={styles.comercianteImg}>
              <img src="https://firebasestorage.googleapis.com/v0/b/mercadeiro-896b2.appspot.com/o/misc%2Fseller-r.svg?alt=media"
                alt=""
                className="img-fluid" />
              {/* <StaticImage src="../images/seller-r.svg" alt="Comerciante" /> */}
            </div>

            <div className={"p-lg-5 " + styles.desenvolvedorTxt}>
              <h1>
                <strong className="text-success o-80">
                  DESENVOLVEDOR
                </strong>
              </h1>
              <h2 className="txt-bold">
                Seus clientes querem vender online <span className="text-success">integrados</span> com seu ERP?
              </h2>
              <Link className="text-success"
                to="desenvolvedor">
                <button type="button"
                  className="btn btn-outline-success btn-lg mt-4">
                  Quero saber mais...
                </button>
              </Link>
            </div>

            <div className={styles.desenvolvedorImg}>
              <img src="https://firebasestorage.googleapis.com/v0/b/mercadeiro-896b2.appspot.com/o/misc%2Fbuyer-l.svg?alt=media"
                alt=""
                className="img-fluid" />
            </div>
          </div>
        </section>

        <section id="integracao"
          className="py-5 p-lg-5 text-center bg-light">
          <div className="container">
            <div className="cols-50 d-flex align-items-center justify-content-center">
              <div className="flex-1 py-1 p-lg-5">
                <h1>
                  <strong className="text-warning o-80">
                    INTEGRAÇÃO
                  </strong>
                </h1>
                <h2 className="txt-bold">
                  Nossa parceria com o desenvolvedor de seu <span className="text-warning">sistema gerencial </span>
                  <span className="o-30">(ERP)</span>, garante que você
                  tenha o mínimo de <span className="text-warning">trabalho adicional</span> para manter sua loja
                  virtual <span className="text-warning">sincronizada</span> com sua loja física.
                </h2>
              </div>

              <div className="flex-1 p-5">
                <img src="/img/icons/link.svg"
                  alt=""
                  className="img-fluid floating-up" />
                {/* <StaticImage src="../images/seller-r.svg" alt="Comerciante" /> */}
              </div>
            </div>
          </div>
        </section>

        <section id="suporte"
          className="py-5 p-lg-5 text-center bg-white">
          <div className="container">
            <div className="cols-50 d-flex align-items-center justify-content-center">
              <div className="flex-1 py-5">
                <img src="/img/icons/chat.svg"
                  alt=""
                  className="img-fluid floating-up" />
              </div>

              <div className="flex-1 py-1 p-lg-5">
                <h1>
                  <strong className="text-success o-80">
                    SUPORTE
                  </strong>
                </h1>
                <h2 className="txt-bold">
                  A criação de uma loja online funcional é um grande <span className="text-success">desafio</span>.
                  Entretanto você não estará sozinho, um <span className="text-success">agente
                    local</span> capacitado
                  irá auxiliá-lo durante toda sua estadia na plataforma.
                </h2>
                <Link className="text-success"
                  to="suporte">
                  <button type="button"
                    className="btn btn-outline-success btn-lg mt-4">
                    Quero saber mais...
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section id="base-produtos"
          className="py-5 p-lg-5 text-center bg-light">
          <div className="container">
            <div className="cols-50 d-flex align-items-center justify-content-center">
              <div className="flex-1 py-1 p-lg-5">
                <h1>
                  <strong className="text-warning o-80">
                    BASE DE PRODUTOS
                  </strong>
                </h1>
                <h2 className="txt-bold">
                  A correta <span className="text-warning o-60">apresentação</span> dos produtos em sua loja virtual
                  é
                  primordial. Por isso, disponibilizados e mantemos uma <span className="text-warning o-60">base de
                    produtos</span> com imagens,
                  descrições, etc... que vão assegurar uma <span className="text-warning o-60">excelente
                    exibição</span> online
                  de seus
                  produtos.
                </h2>
                <Link className="text-warning"
                  to="base-produtos">
                  <button type="button"
                    className="btn btn-outline-warning btn-lg mt-4">
                    Quero saber mais...
                  </button>
                </Link>
              </div>

              <div className="flex-1 p-5">
                <img src="/img/icons/barcode.svg"
                  alt=""
                  className="img-fluid floating-up" />
              </div>
            </div>
          </div>
        </section>

        <section id="loja-modelo"
          className="s-ajuda py-5 bg-white text-dark text-center text-md-left bg-light">
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-12 col-md-12 text-center order-last order-md-first">
                <div>
                  <h1 className="txt-bold">
                    Veja um exemplo de como ficará sua loja.
                  </h1>
                </div>
                <br />

                {/* <p>{lojaModeloTab}</p> */}
                <div className="row mb-5 segment">
                  <div className="col-12 col-sm-6 offset-sm-3">
                    <ul className="nav nav-pills nav-fill">
                      <li className="nav-item pointer"
                        onClick={() => setLojaModeloTab('desktop')}>
                        <a className={`nav-link
                              ${lojaModeloTab === 'desktop'
                            ? 'active'
                            : ''
                          }`}>
                          Desktop
                        </a>
                      </li>

                      <li className="nav-item pointer"
                        onClick={() => setLojaModeloTab('mobile')}>
                        <a className={`nav-link
                              ${lojaModeloTab === 'mobile'
                            ? 'active'
                            : ''
                          }`}>
                          Mobile
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-12 col-md-8 offset-md-2 text-center">
                  {
                    lojaModeloTab === 'desktop'
                      ? <Slider {...SETTINGS_DESKTOP}>
                        {
                          SLIDES_DESKTOP.map(slide => (
                            <img src={slide}
                              key={slide}
                              style={{
                                height: "50%"
                              }}
                              alt="" />
                          ))
                        }
                      </Slider>
                      : <Slider {...SETTINGS_MOBILE}>
                        {
                          SLIDES_MOBILE.map(slide => (
                            <div className="mr-5">
                              <img alt=""
                                className="img-fluid"
                                src={slide}
                                key={slide}
                                style={
                                  {
                                    height: "50%"
                                    ,
                                  }
                                } />
                            </div>
                          ))
                        }
                      </Slider>
                  }
                </div>

                <a className="text-dark"
                  href="https://sandbox.mercadeiro.com.br/#/loja/supermercado-modelo--mg--uberaba--merces--rua-antonio-borges-de-araujo/false"
                  target="_blank"
                  rel="noreferrer">
                  <button type="button"
                    className="btn btn-outline-dark btn-lg mt-5">
                    Visite nossa loja modelo.
                  </button>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section id="material-apoio"
          className="py-5 p-lg-5 text-center bg-light">
          <div className="container">
            <div className="cols-50 d-flex align-items-center justify-content-center">
              <div className="flex-1 py-1 p-lg-5">
                <h1>
                  <strong className="text-warning o-80">
                    MATERIAL DE APOIO
                  </strong>
                </h1>
                <h2 className="txt-bold">
                  Para o sucesso de sua loja online, é essencial <span
                    className="text-warning o-60">divulgá-la</span> para seus clientes. Para ajudá-lo,
                  disponibilizamos <span className="text-warning o-60">artes publicitárias</span> de diversos <span
                    className="text-warning o-60">materiais de apoio</span> personalizados para sua loja.
                </h2>
                <Link className="text-warning"
                  to="material-apoio">
                  <button type="button"
                    className="btn btn-outline-warning btn-lg mt-4">
                    Quero saber mais...
                  </button>
                </Link>
              </div>

              <div className="flex-1 p-5">
                <img src="/img/icons/share.svg"
                  alt=""
                  className="img-fluid floating-up" />
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}
